var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-section',{attrs:{"source":"Landing/Logos"}})}
var staticRenderFns = []

export { render, staticRenderFns }